import Api from './../api'
import DataLayer from './../data-layer/index'

DataLayer.$extend('shows', {
    getById(id) {
        return Api.shows.get({ id })
    },
})
